import { Injectable } from '@angular/core';
import { ReportesRequestService } from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioAfiliadoService {

  constructor(private requestUrl: ReportesRequestService) { }

  async getInformacionAfiliado( codigo: string, uncoAfiliado: number) {
    try {
      const response = await this.requestUrl.getRequest(
        'afiliados/dato-afiliado',
        [
          codigo,
          {
            'unco' : uncoAfiliado
          }
        ]);
      return response;
    }catch(e) {
      console.log(`ServicioAfiliadoService.getInformacionAfiliado() ${e}`);
    }
  }
}

export interface AfiliadoEntity {
  unco ?: number;
  primerNombre ?: string;
  segundoNombre ?: string;
  primerApellido ?: string;
  segundoApellido ?: string;
  fechaNacimiento ?: number;
  direccion ?: string;
  email ?: string;
  telefono ?: string;
  celular ?: string;
  codigoSexo ?: string;
  tipoDocumento ?: string;
  numeroIdentificacion ?: string;
  edad ?: EdadEntity;
  nombreCompleto ?: string;
  identificacionCompleta ?: string;
}

interface EdadEntity {
  anos ?: number;
  meses ?: number;
  dias ?: number;
}